class AuditoriaEstoqueLinkService extends AbstractService

  configure: (configs, injector) ->
    configs.url = '/'

  getList: (empresa, callback) ->
    @doRequest('GET', {empresa_id: empresa}, callback, url: "/api/auditoria-tributaria/estoque/link")

  delete: (empresa, link, callback) ->
    @doRequest('DELETE', {empresa_id: empresa}, callback, url: "/api/auditoria-tributaria/estoque/link/#{link}")

  create: (empresa, filtro, campos, descricao, callback) ->
    @doRequest('POST', {link: {filtro: filtro, campos: campos, descricao: descricao}, empresa_id: empresa}, callback, url: "/api/auditoria-tributaria/estoque/link")

  enviarEmail: (link, email, callback) ->
    @doRequest('POST', {email: email}, callback, url: "/api/auditoria-tributaria/estoque/link/#{link.id}/enviar")

angular.module('eficienciaFiscalModule').service('auditoriaEstoqueLinkService', AuditoriaEstoqueLinkService)
